module.exports = __webpack_public_path__ + "img/shopee.ba409a7b.png";